import logo from "./logo.svg";
import React from "react";
import "./App.css";

import {
  AppBar,
  Box,
  Slide,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  Button,
  ListItem,
  CardMedia,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import AOS from "aos";
import Home from "./component/home";
import Info from "./component/information";
import Formula from "./component/formula";
import Faq from "./component/faqNew";
import GetDownload from "./component/download";
import HorizontalScrolling from "./component/horizontalScrolling";
import Carousel from "./component/carousel";
import { DESKTOP_DATA, MOBILE_DATA } from "./utils/data";
import { DESKTOP_DATA2, MOBILE_DATA2 } from "./utils/data2";
import CallIcon from "@mui/icons-material/Call";
import NewFeature from "./component/newFeature";
const drawerWidth = 240;
const navItems = [
  "หน้าแรก",
  "รู้จัก MLS",
  "แนะนำเข้าใช้งาน",
  "ฟีเจอร์ใหม่",
  "สื่อประชาสัมพันธ์",
  "สมมติฐานที่ใช้คำนวณ",
  "คำถามที่พบบ่อย",
  "ดาวน์โหลดติดตั้งแอป",
];

function App() {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [menuIndex, setMenuIndex] = React.useState(0);

  const AppBarRef = React.useRef(null);

  const HomeSection = React.useRef(null);
  const horizontalScrollingSection = React.useRef(null);
  const carouselSection = React.useRef(null);
  const FeatureSection = React.useRef(null);
  const InfoSection = React.useRef(null);
  const FormuSection = React.useRef(null);
  const FaqSection = React.useRef(null);
  const DownloadSection = React.useRef(null);
  const NewFeatureSection = React.useRef(null);

  const [wh, setRealwidth] = React.useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  const [scrollPosition, setScrollPosition] = React.useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  React.useEffect(() => {
    const H = AppBarHeight();

    const tops = {
      feature: FeatureSection.current?.offsetTop ?? 0,
      carousel: carouselSection.current?.offsetTop ?? 0,
      newFeature: NewFeatureSection.current?.offsetTop ?? 0,
      info: InfoSection.current?.offsetTop ?? 0,
      formu: FormuSection.current?.offsetTop ?? 0,
      faq: FaqSection.current?.offsetTop ?? 0,
      download: DownloadSection.current?.offsetTop ?? 0,
      horizontal: horizontalScrollingSection.current?.offsetTop ?? Number.POSITIVE_INFINITY,
    };

    // ลำดับต้องตรงกับที่ render จริงในหน้า:
    // Home -> Feature -> Try -> NewFeature -> Info -> Formu -> Faq -> Download -> (horizontal ต่อท้าย)
    const sections = [
      { i: 0, top: 0, next: tops.carousel - H },
      { i: 1, top: tops.carousel - H, next: tops.horizontal - H },
      { i: 2, top: tops.horizontal - H, next: tops.newFeature - H },
      { i: 3, top: tops.newFeature - H, next: tops.info - H },
      { i: 4, top: tops.info - H, next: tops.formu - H },
      { i: 5, top: tops.formu - H, next: tops.faq - H },
      { i: 6, top: tops.faq - H, next: tops.download - H },
      // เมนูสุดท้ายครอบทั้ง Download และส่วนที่อยู่ถัดไป (horizontal)
      { i: 7, top: tops.download - H, next: Number.POSITIVE_INFINITY },
    ];

    const s = sections.find(s => scrollPosition >= s.top && scrollPosition < s.next);
    if (s && s.i !== menuIndex) setMenuIndex(s.i);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPosition, wh]);


  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  React.useEffect(() => {
    function handleWindowResize() {
      setRealwidth([window.innerWidth, window.innerHeight]);
    }
    AOS.init({ duration: 1500 });

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const AppBarHeight = () => {
    if (AppBarRef.current != null) {
      return AppBarRef.current.offsetHeight + 50;
    }
    return 0;
  };

  const ChangePage = (i) => {
    setMenuIndex(i);
    if (i === 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (i === 1) {
      window.scrollTo({ top: carouselSection.current.offsetTop - AppBarHeight(), behavior: "smooth" });
    } else if (i === 2) {
      window.scrollTo({ top: horizontalScrollingSection.current.offsetTop + 1 - AppBarHeight(), behavior: "smooth" });
    } else if (i === 3) {
      window.scrollTo({ top: NewFeatureSection.current.offsetTop + 1, behavior: "smooth" });
    } else if (i === 4) {
      window.scrollTo({ top: InfoSection.current.offsetTop + 1, behavior: "smooth" });
    } else if (i === 5) {
      window.scrollTo({ top: FormuSection.current.offsetTop + 1, behavior: "smooth" });
    } else if (i === 6) {
      window.scrollTo({ top: FaqSection.current.offsetTop + 1, behavior: "smooth" });
    } else if (i === 7) {
      window.scrollTo({ top: DownloadSection.current.offsetTop + 1, behavior: "smooth" });
    }
  };


  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <List>
        {navItems.map((item, i) => (
          <ListItem
            className={
              item === navItems[menuIndex]
                ? "border-primary bg-header text-light"
                : ""
            }
            onClick={() => ChangePage(i)}
            key={item}
            sx={{ borderRadius: 20 }}
            disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box>
      <Slide in={true} timeout={600}>
        <AppBar
          ref={AppBarRef}
          component="nav"
          className="appbarcolor"
          style={{ background: "transparent", boxShadow: "none" }}>
          <Toolbar>
            <IconButton
              className="colorbase"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { md: "none" } }}>
              <MenuIcon />
            </IconButton>
            <Box sx={{ flexGrow: 1 }}>
              <CardMedia
                src="https://www.gpf.or.th/thai2019/assets/logo-n.png"
                component="img"
                sx={{ width: 120 }}
              />
            </Box>

            <Box sx={{ display: { xs: "none", md: "block" }, flexGrow: 0.11 }}>
              {navItems.map((item, i) => (
                <Button
                  className={
                    item === navItems[menuIndex]
                      ? "border-primary bg-header"
                      : "colorbase"
                  }
                  onClick={() => ChangePage(i)}
                  key={item}
                  sx={{ color: "#fff", borderRadius: 20 }}>
                  {item}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: wh[0] < 900 ? "flex" : "none" }}>
              <Typography className="colorbase">
                {navItems[menuIndex]}
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>
      </Slide>
      <Box component="nav">
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}>
          {drawer}
        </Drawer>
      </Box>
      <Box component="main">
        <Toolbar />

        <div ref={HomeSection}>
          <Home width={wh[0]} />
        </div>
        <div
          ref={carouselSection}
          style={{ marginTop: AppBarHeight() }}>
          <Carousel
            itemWidth={800}
            viewportWidth={1400}
            gap={12}
            centerActive
          />
        </div>
        <div
          ref={horizontalScrollingSection}
          style={{ marginTop: AppBarHeight() }}>
          <HorizontalScrolling
            itemWidth={300}
            gap={12}
            cardHeight={600}  
          />
        </div>
        <div ref={NewFeatureSection} style={{ marginTop: AppBarHeight() }}>
          <NewFeature />
        </div>
        <div ref={InfoSection} style={{ marginTop: AppBarHeight() }}>
          <Info />
        </div>
        <div ref={FormuSection} style={{ marginTop: AppBarHeight() }}>
          <Formula width={wh[0]} />
        </div>
        <div ref={FaqSection} style={{ marginTop: AppBarHeight() }}>
          <Faq appbarHeight={AppBarHeight()} width={wh[0]} />
        </div>

        <div
          ref={DownloadSection}
          style={{ marginTop: AppBarHeight() }}>
          <GetDownload />
        </div>

        <footer className="bg-header text-light text-center pt-2 pb-2">
          ติดต่อสอบถาม :{" "}
          <a className="text-light" href="tel:+661179">
            {" "}
            Contact Center โทร. 1179
          </a>{" "}
          <b>|</b> LINE กบข. :{" "}
          <a
            className="text-light"
            href="https://lin.ee/pg7w6hn"
            target="_blank">
            @gpfcommunity
          </a>{" "}
          <b>|</b> เสนอแนะ / ร้องเรียน :{" "}
          <a
            className="text-light"
            href="https://www.gpf.or.th"
            target="_blank">
            เมนู "ติดต่อเรา" www.gpf.or.th
          </a>
        </footer>
      </Box>
    </Box>
  );
}

export default App;
